<template>
    <div class="topFixedWrap" id="topFixedWrap">
        <!-- 一级导航 -->
        <!-- <nav class="nav" :class="{'nav-new':isExternalAccess}"> -->
        <nav class="nav">
            <!-- <span class="new-logo-wrap" v-if="isExternalAccess"><img src="../assets/logoNew.png" alt="" class="logo-new">All Football</span> -->
            <router-link :to="item" v-for="(item,index) in navMap" :key='index'>
                <span class="selected" v-if="navSelected == index"></span>{{index}}
            </router-link>
            <!-- <a :href="item" v-for="(item,index) in navMap" :key='index'><span class="selected" v-if="navSelected == index"></span>{{index}}</a> -->
        </nav>
        <!-- 二级导航 -->
        <nav class="newsSubTit">
            <p class="newTit" id="scroll">
                <a @click.prevent="subTitToggle(item,index)"
                   :href="`/${getUrlTitle(navMap[navSelected])}/${getUrlTitle(item.label)}`"
                   :class="{'subTitSelected':getSubtitChoose==item.label,'pad':pad}"
                   v-for="(item,index) in subtitleData" :key="index">{{item.label}}</a>
            </p>
        </nav>
        <!-- 三级导航 暂时没有 -->
        <nav class="nav thirdTitwrap" v-if='isThirdTit'>
            <div class="thirdTit">
                <a href="javascript:;" @click="thirdTitleToggle(item,index)" v-for="(item,index) in thirdTotalTitle"
                   :class="{'thirdTitSelected':getThirdTitChoose === item.title, 'thirdTitWidth': thirdTotalTitle.length < 4}" :key="index">{{item.title}}</a>
            </div>
        </nav>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'navVue',
        props: ['subtitleData', 'navSelected', 'isThirdTit', 'pad', 'loadingShowProp'],
        data: function () {
            return {
                subtitData: [],
                thirdTotalTitle: [],
                navMap: {
                    'NEWS': '/news',
                    'MATCH': '/matchs',
                    'VIDEO': '/video',
                    'STATS': '/stats'
                },
                currentListData: [], // 当前选中tab下的所有数据
                loading: false,
                subNavTranslateX: function () {},
                stickyFn: function () {},
                googlePlayUrl: 'intent://open/#Intent;scheme=allfootball;package=com.allfootball.news;end',
                isExternalAccess: null
            };
        },
        computed: {
            ...mapGetters([
                'getSubtitChoose',
                'getThirdTitChoose'
            ]),
            statsSubTabList () {
                return this.$store.state.navStore.statsSubTabList;
            }
        },
        created: function () {
            if (this.navSelected === 'STATS') {
                this.statsSubTabList.length && this.statsSubTabList.map((elem, i) => {
                    if (this.getSubtitChoose === elem.label || (i === 0 && !this.getSubtitChoose)) {
                        this.thirdTotalTitle = elem.urlApi;
                    }
                });
                this.$store.commit('setThirdTitChoose', (this.thirdTotalTitle.length && this.thirdTotalTitle[0].title) || 'Table');
            }
        },
        methods: {
            subNavEmit: function () {
                // 触发父组件的方法回填数据，引入vuex之后不用了
                // return;
                // 更新父组件副导航展示，以及传递参数用以更新内容列表
                // this.$emit('subNavDataFromchild', {
                //     loadingShowObj: true,
                //     noDataModeObj: false,
                //     tabTagObj: false,
                //     goalTagObj: false,
                //     assTagObj: false,
                //     fixtureTagObj: false,
                //     getSubtitChooseObj: this.getSubtitChoose,
                //     thirdTitChooseObj: this.thirdTitChoose,
                //     getDataUrlApiObj: this.getDataUrlApi.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')
                // });
            },
            thirdNavEmit: function () {
                // 更新父组件副导航展示，以及传递参数用以更新新闻列表
                // this.$emit('thirdNavDataFromchild', {
                //     loadingShowObj: true,
                //     noDataModeObj: false,
                //     tabTagObj: false,
                //     goalTagObj: false,
                //     assTagObj: false,
                //     fixtureTagObj: false,
                //     thirdTitChooseObj: this.thirdTitChoose,
                //     thirdTitChooseUrl: this.thirdTitChooseUrl.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')
                // });
            },
            subTitToggle: function (item, index) {
                if (this.loadingShowProp) return;
                if (this.getSubtitChoose === item.label) return;
                // 空格 转成 -
                const subTitle = this.getUrlTitle(item.label);
                if (this.$route.params.subtitle) {
                    history.replaceState(null, null, `./${subTitle}`);
                } else {
                    history.replaceState(null, null, `${this.$route.path}/${subTitle}`);
                }
                this.subNavTranslateX(index);
                this.scrollFn(item.label);
                if (!this.isThirdTit) { // 只有两级导航时
                    this.subNavTranslateX(index);
                    this.scrollFn(item.label);
                    // 获取点击二级导航后对数据
                    this.$store.commit('setSubtitChoose', item.label);
                    // 原来是回调Apphome的方法回调列表数据
                    const urlApi = item.urlApi;
                    if (this.navSelected === 'NEWS') {
                        this.$store.dispatch('newsListApi', { urlApi });
                    } else if (this.navSelected === 'MATCH') {
                        const finalDate = this.dateToUtc();
                        this.$store.dispatch('matchListApi', { urlApi, finalDate });
                    } else if (this.navSelected === 'VIDEO') {
                        this.$store.dispatch('videoListApi', { urlApi, type: 1 });
                    }
                } else { // 有三级导航时
                    if (this.navSelected === 'STATS') {
                        const urlApi = (item.urlApi && item.urlApi[0].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')) || '';
                        this.statsSubTabList.length && this.statsSubTabList.map((elem, i) => {
                            if (item.label === elem.label) {
                                this.thirdTotalTitle = elem.urlApi;
                            }
                        });
                        this.$store.commit('setSubtitChoose', item.label);
                        this.$store.commit('setThirdTitChoose', 'Table');
                        this.$store.dispatch('statsListApi', { urlApi, thirdTitChoose: 'Table' });
                    }
                }
            },
            thirdTitleToggle: function (elem, index) {
                if (this.loadingShowProp) {
                    return;
                }
                if (this.getThirdTitChoose === elem.title) {
                    return;
                }
                this.$store.commit('setThirdTitChoose', elem.title);
                this.scrollFn(this.getSubtitChoose);
                if (this.navSelected === 'STATS') {
                    const urlApi = (elem.url && elem.url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')) || '';
                    this.$store.dispatch('statsListApi', { urlApi, thirdTitChoose: elem.title });
                }
            },
            scrollFn: function (label) {
                let that = this;
                window.browers = {};
                let ua = navigator.userAgent.toLowerCase();
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);

                let headwrap = document.getElementById('headwrap');
                let headHeight = headwrap.offsetHeight;// 下载条高度
                let topFixedWrap = document.getElementById('topFixedWrap');
                // let topFixedWrapHeight = topFixedWrap.offsetHeight;// 被定住的位置的高度
                let contentWrap = document.getElementById('contentWrap');// 每个二级导航下的列表内容
                if (document.body.scrollTop || document.documentElement.scrollTop >= headwrap.offsetHeight) {
                    console.log('*隐藏了下载引导模块');
                    this.downLoadHeaderShow = false;
                    setTimeout(function () {
                        that.downLoadHeaderShow = true;
                    }, 10);
                    if (browers.Android) {
                        console.log('*********');

                        topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                        setTimeout(function () {
                            topFixedWrap.className = 'topFixedWrap';
                        }, 10);
                        contentWrap.style.paddingTop = 0 + 'px';
                        console.log(contentWrap.style.paddingTop);
                    } else if (browers.iOS) {
                        console.log('&&&&&&&&');
                        topFixedWrap.className = 'topFixedWrap';
                        contentWrap.style.paddingTop = 0 + 'px';
                    }
                    // 滚动到吸顶位置
                    setTimeout(function () {
                        console.log('**滚了 ', headHeight);
                        document.body.scrollTop = headHeight;
                        document.documentElement.scrollTop = headHeight;
                    }, 10);
                    console.log('document.body.scrollTop:' + document.body.scrollTop);
                } else {
                    if (browers.Android) {
                        topFixedWrap.className = 'topFixedWrap';
                        contentWrap.style.paddingTop = 0 + 'px';
                    }
                }
            },
            dateToUtc: function () {
                let date = new Date();
                let localYear = date.getFullYear();
                let localMonth = date.getMonth() + 1;
                let localDay = date.getDate();
                let localDate = localYear + '/' + localMonth + '/' + localDay + ' 00:00:00';
                let finalLocal = new Date(localDate);
                let finalLocalDate = finalLocal.getTime();
                let diffMin = new Date().getTimezoneOffset();
                let utcTime = finalLocalDate + diffMin * 60 * 1000;
                let utc = new Date(utcTime);
                let y = utc.getFullYear();
                let m = utc.getMonth() + 1;
                let d = utc.getDate();
                let h = utc.getHours();
                let min = utc.getMinutes();
                let s = utc.getSeconds();
                // let finalDate = '' + y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
                return '' + y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
            }
        },
        mounted: function () {
            this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;
            if (this.isExternalAccess) {
                import('@/util/sys-color-qszq.css').then(module => {
                    console.log('module',module)
                // CSS 已加载
                // 如果使用 CSS Modules，可以通过 module.default 访问
                });
            } else {
                import('@/util/sys-color.css').then(module => {
                // CSS 已加载
                });
            }
            console.log('window.location.hostname2', this.isExternalAccess, window.location.hostname)
            this.subNavTranslateX = function (index) {
                // 二级导航点击移动效果
                let scrollBar = document.getElementById('scroll');
                let scrollBarTab = scrollBar.querySelectorAll('a');
                let screenWidth = document.documentElement.clientWidth; // 屏幕宽度
                this.scrollLeft = scrollBar.scrollLeft;
                this.leftToScreen = scrollBarTab[index].getBoundingClientRect().left;
                this.rightToScreen = screenWidth - (this.leftToScreen + scrollBarTab[index].getBoundingClientRect().width);
                let average = (this.leftToScreen + this.rightToScreen) / 2;
                if (this.leftToScreen < this.rightToScreen) {
                    scrollBar.scrollLeft -= (average - this.leftToScreen);
                } else {
                    scrollBar.scrollLeft += (average - this.rightToScreen);
                }
            };
        }
    };
</script>
<style lang="less" scoped>
    .nav {
        margin: 0;
        padding: 0;
        height: 2.4rem;
        background: var(--mainColor);
        line-height: 2.4rem;
        overflow: hidden;
    }

    .nav a {
        width: 24.3%;
        // display: inline-block;
        text-align: center;
        color: #fff;
        font-size: 0.9rem;
        float: left;
        text-decoration: none !important;
        position: relative;
        // line-height:2.4rem;
        // height:2.4rem;
        height: 1.4rem;
        line-height: 1.4rem;
        padding: .5rem 0;
        overflow: hidden;
        font-weight: bold;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .selected {
        display: inline-block;
        width: .5rem;
        height: .4rem;
        line-height: 1.2rem;
        background: url("../assets/home/home_arrow.png") no-repeat;
        background-size: 100% auto;
        position: absolute;
        bottom: -.1rem;
        left: 50%;
        margin-left: -.2rem;
        z-index: 10;
    }

    .newsSubTit {
        height: 2.2rem;
        width: 100%;
        font-size: 0.68rem;
        line-height: 2.5rem;
        text-align: center;
        color: #2d2f32;
        border-bottom: 0.01rem solid #eff1f4;
        background: #fff;
    }

    .newsSubTit p {
        height: 2.4rem;
        overflow: scroll;
        white-space: nowrap;
        padding: 0 .8rem;
        position: relative;
        top: 0rem;
        -webkit-overflow-scrolling: touch;
    }

    *:not(html) {
        -webkit-transform: translate3d(0, 0, 0);
    }

    .newsSubTit a {
        display: inline-block;
        padding: 0 .7rem;
        position: relative;
        // height: 2.2rem;
        // padding: .55rem 0;
        height: 1.1rem;
        line-height: 1.1rem;
        padding: .3rem .7rem;
        color: #2d2f32;

        font-size: .9rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        // top: -0.1rem;
    }

    .newsSubTit p::-webkit-scrollbar {
        display: none;
    }

    .subTitSelected {
        color: var(--mainColor) !important;
        border-bottom: .15rem solid var(--mainColor);
    }

    /*stat 三级导航*/
    .thirdTitwrap {
        height: 3.2rem;
        background: #333d46;
        overflow: hidden;
        color: #929cad;
    }

    .thirdTit {
        height: 1.5rem;
        width: 94%;
        margin: .8rem auto;
        line-height: 1.5rem;
        border: 1px solid #1d2328;
        border-radius: 0.01rem;
    }

    .thirdTit a {
        width: 25%;
        color: #929cad;
        /*display: inline-block;*/
        float: left;
        text-align: center;
        border-right: 1px solid #1d2328;
        text-decoration: none;
        box-sizing: border-box;
        height: 1.5rem;
        line-height: 1.5rem;
        font-size: .8rem;
        padding: 0;
    }
    .thirdTitWidth {
        width: 33.3% !important;
    }
    .thirdTit > a.thirdTitSelected {
        background: #1d2328 !important;
        color: #fff !important;
    }

    .thirdTit > a:last-of-type {
        border-right: none;
    }

    /*定位*/
    .topFixedWrap {
        width: 100%;
        z-index: 100;
        position: -webkit-sticky;
        position: -moz-sticky;
        position: -ms-sticky;
        position: -o-sticky;
        position: sticky;
        top: 0rem;
    }

    //Android
    .main > .tab-box-fixed {
        position: fixed !important;
        z-index: 10;
        top: 0;
        left: 0;
    }

    .main > .tab-box-testFix {
        z-index: 10;
        top: 0;
        left: 0;
    }

    //iOS
    .tab-box-sticky {
        position: -webkit-sticky;
        position: -moz-sticky;
        position: -ms-sticky;
        position: -o-sticky;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 10;
    }

    .pad {
        margin: 0 3rem;
    }
    
    .nav-new a{
        width: 18%;
        display: flex;
        justify-content: right;
        .selected{
            margin-left: 0.6rem !important;
        }
    }
    .new-logo-wrap{
        font-family: sans-serif;
        font-weight: bolder;
        font-size: 0.88rem;
        color: #FFFFFF;
        float: left;
        margin-left: 0.4rem;
        letter-spacing: -1px;
        .logo-new{
            width: 0.9rem;
            margin-right: 0.2rem;
            top: 0.1rem;
            position: relative;
        }
    }
</style>



// WEBPACK FOOTER //
// navNew.vue?5f2409dd